import { Typography } from '@mui/material';
import { getCountryName } from '@ovComponents/resources';

export const CountryName = ({ code }: { code: string }) => (
  <Typography>{getCountryName(code) || code}</Typography>
);
